var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 p-0"},[_c('iframe',{staticStyle:{"border":"0","width":"100%","min-height":"calc(100vh - 80px)","box-sizing":"border-box"},attrs:{"src":"https://lookerstudio.google.com/embed/reporting/e6074eac-3d8f-479d-bde0-64676c3d3e34/page/p_nsjqs38rwc","frameborder":"0","allowfullscreen":""}})])])])
}]

export { render, staticRenderFns }